module.exports = __webpack_public_path__ + "img/record.7e966772.png";